import {UseMutationResult, useMutation} from '@tanstack/react-query';
import ChessRestClient from '@/Api/ChessRestClient';

interface GetStudentsListPayload {
  meetingId: string;
  occurenceId: string;
}

export default function useGetStudentsListApi(
  handleOnSuccess?: (data: any) => void,
  handleOnError?: (error: unknown) => void,
): UseMutationResult<any, unknown, GetStudentsListPayload> {
  return useMutation<any, unknown, GetStudentsListPayload>(
    async (payload: GetStudentsListPayload) => {
      const response = await ChessRestClient.post(
        'classroom/v1/get_completed_puzzles_students_list/',
        payload,
      );
      console.log(
        'get Completed Classroom Puzzles For Coach response ',
        response.data,
      );
      return response.data;
    },
    {
      onSuccess: (data: any) => {
        if (handleOnSuccess) {
          handleOnSuccess(data);
        }
      },
      onError: (error: unknown) => {
        console.error(
          'Failed to get Completed Classroom Puzzles For Coach :',
          error,
        );
        if (handleOnError) {
          handleOnError(error);
        }
      },
    },
  );
}
